import type { MemoryAssociableEntityIds } from 'clerk_common';

type EmailThreadEntitySource = {
  originator?: { id?: string | null } | null;
  orders?: Array<{
    id: string;
    originator?: { id?: string | null } | null;
  }>;
  quotes?: Array<{ id: string }>;
};

export function collectEmailThreadEntityIds(
  jobs: EmailThreadEntitySource[]
): MemoryAssociableEntityIds {
  const orders = uniqueIds(jobs.flatMap((job) => job.orders ?? []));
  const quotes = uniqueIds(jobs.flatMap((job) => job.quotes ?? []));
  const originators = uniqueIds([
    ...jobs.map((job) => job.originator),
    ...jobs.flatMap(
      (job) => job.orders?.map((order) => order.originator) ?? []
    ),
  ]);

  return {
    ...(orders.length > 0 ? { orders } : {}),
    ...(originators.length > 0 ? { originators } : {}),
    ...(quotes.length > 0 ? { quotes } : {}),
  };
}

function uniqueIds(
  entities: Array<{ id?: string | null } | null | undefined>
): string[] {
  return Array.from(
    new Set(entities.flatMap((entity) => (entity?.id ? [entity.id] : [])))
  );
}
